// Team — command operator roster + invite. Lists users with role='command' (from the users table)
// and lets an operator invite a new command member (Cognito user + command group; Cognito emails
// the invite). Identifiers only — no PHI on this surface.
import { useState } from "react";
import { useApi } from "../api";
import { useAsync } from "../lib/useAsync";
import { InviteStaff } from "../components/InviteStaff";
import { Loading, ErrorState, EmptyState, PageHeader } from "../components/ui";

export function Team() {
  const api = useApi();
  const [inviting, setInviting] = useState(false);
  const { data, loading, error, reload } = useAsync(() => api.listStaff("command"), []);
  if (loading && !data) return <Loading />;
  if (error) return <ErrorState message={error} />;
  const rows = data ?? [];

  return (
    <div className="page">
      <PageHeader
        title="Team"
        sub={`${rows.length} operators`}
        actions={
          <button className="pbtn pbtn--primary" onClick={() => setInviting((v) => !v)}>
            {inviting ? "Cancel" : "Invite operator"}
          </button>
        }
      />
      {inviting && (
        <InviteStaff
          role="command"
          onInvited={reload}
          onClose={() => setInviting(false)}
        />
      )}
      <div className="ptbl-wrap">
        <table className="ptbl">
          <thead>
            <tr>
              <th>Email</th>
              <th>Added</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((s) => (
                <tr key={s.id} className="ptbl-row">
                  <td>{s.email}</td>
                  <td>{new Date(s.created_at).toLocaleDateString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2}>
                  <EmptyState>No operators yet.</EmptyState>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
